import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

// Components
import { DrawTable } from './DrawTable';
import { PageStructure } from 'js/components/TriiboComponents/PageStructure/PageStructure';
import { SearchBarWithButton } from 'js/components/TriiboComponents/SearchBarWithButton/SearchBarWithButton';

// Apis
import { getAllRafflesOfPartner } from 'js/library/utils/API/Draws/getAllRafflesOfPartner';

export function Draw() {
  const partnerId = localStorage.getItem('partnerIdClube');

  const [drawList, setDrawList] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [reload, setReload] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    (async function fetchDataAllRafflesOfPartner() {
      try {
        const response = await getAllRafflesOfPartner(partnerId);

        setDrawList(response);
      } catch (error) {
        toast.error(error);
      } finally {
        setLoadingTable(false);
      }
    })();
  }, [partnerId, reload]);

  const filteredDrawList = useMemo(() => {
    if (!searchValue.trim()) return drawList;
    return drawList.filter((draw) => String(draw.campaignId).includes(searchValue.trim()));
  }, [drawList, searchValue]);

  return (
    <PageStructure title="Sorteios">
      <SearchBarWithButton
        buttonLabel="Criar sorteio"
        placeHolderSearch="Pesquisar sorteio"
        setValueSearch={setSearchValue}
        valueSearch={searchValue}
        urlExtension="criar"
      />

      <DrawTable drawList={filteredDrawList} loadingTable={loadingTable} reload={setReload} />
    </PageStructure>
  );
}
